export const createMediaStreamTrackGenerator: {
    (init: MediaStreamAudioTrackGeneratorInit): MediaStreamAudioTrackGenerator;
    (init: MediaStreamVideoTrackGeneratorInit): MediaStreamVideoTrackGenerator;
} = init => {
    const generator = new MediaStreamTrackGenerator(init);
    return generator;
};
